import { Loader2, Plus, Tags } from 'lucide-react';

import ActionButton from '../../../../components/Buttons/ActionButton';
import SelectField from '../../../../components/Forms/Input/SelectField';

import { IBranchDropdown } from '../../../../types/branches/branchInterfaces';

interface MenuCategoryHeaderProps {
  branches: IBranchDropdown[];
  branchId: number | '';
  loadingBranches: boolean;
  branchError?: string;
  canPickBranch: boolean;
  onBranchChange: (branchId: number) => void;
  onCreate: () => void;
}

const MenuCategoryHeader = ({
  branches,
  branchId,
  loadingBranches,
  branchError,
  canPickBranch,
  onBranchChange,
  onCreate,
}: MenuCategoryHeaderProps) => {
  return (
    <div className="border-b border-stroke px-5 py-5 dark:border-strokedark sm:px-7">
      <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
        <div className="flex items-start gap-3">
          <span className="rounded-xl border border-primary/15 bg-primary/10 p-2.5 text-primary">
            <Tags className="h-5 w-5" />
          </span>

          <div>
            <h1 className="text-xl font-semibold text-black dark:text-white">
              Categorías del menú
            </h1>

            <p className="mt-1 text-sm text-bodydark2 dark:text-bodydark">
              Organice platillos y bebidas en secciones visuales.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
          {canPickBranch && (
            <div className="w-full sm:w-80">
              {loadingBranches ? (
                <div className="flex h-[74px] items-center justify-center gap-2 text-sm text-bodydark2">
                  <Loader2 className="h-4 w-4 animate-spin text-primary" />
                  Cargando sucursales...
                </div>
              ) : (
                <SelectField
                  label="Sucursal"
                  name="menuCategoryBranch"
                  value={branchId}
                  iconKey="building"
                  placeholder="Seleccione una sucursal"
                  withMargin={false}
                  options={branches.map((branch) => ({
                    value: branch.id,
                    label: branch.name,
                  }))}
                  onChange={(event) =>
                    onBranchChange(Number(event.target.value))
                  }
                />
              )}
            </div>
          )}

          {!loadingBranches && (
            <ActionButton
              label="Nueva categoría"
              icon={<Plus className="h-4 w-4" />}
              variant="primary"
              size="md"
              fullWidth={false}
              disabled={!branchId}
              onClick={onCreate}
              className="h-[50px] whitespace-nowrap px-5"
            />
          )}
        </div>
      </div>

      {branchError && (
        <p className="mt-3 text-sm font-medium text-danger">
          {branchError}
        </p>
      )}
    </div>
  );
};

export default MenuCategoryHeader;